import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "panel-content"
};
import { reactive } from "vue";
import { getThisMonthClassroomOverview } from '@/api/index-guan';
import panelTab from './lib/panelTab';
export default {
  __name: 'teacherOverviewPanel',
  props: {
    cycle: {
      type: String,
      default: ''
    },
    classRoom: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props, _ref) {
    var __expose = _ref.expose;
    var props = __props;
    var state = reactive({
      teacherNum: 0,
      // 学生数量
      studentRate: 0,
      // 参与展示率
      classTimeNum: 0,
      // 课堂提交作品数
      worksPraisedNum: 0,
      // 作品累计获赞数
      detectionRate: 0,
      // 检测正确答率
      paperAnswerRate: 0 // 习练正确答率
    });
    var getPanelOverview = function getPanelOverview() {
      var data = {
        cycle: props.cycle,
        classRoom: props.classRoom
      };
      getThisMonthClassroomOverview(data).then(function (res) {
        var _res$data$data, _res$data$data2, _res$data$data3, _res$data$data4, _res$data$data5, _res$data$data6;
        state.studentNum = ((_res$data$data = res.data.data) === null || _res$data$data === void 0 ? void 0 : _res$data$data.studentNum) || 0;
        state.studentRate = ((_res$data$data2 = res.data.data) === null || _res$data$data2 === void 0 ? void 0 : _res$data$data2.studentRate) || 0;
        state.classTimeNum = ((_res$data$data3 = res.data.data) === null || _res$data$data3 === void 0 ? void 0 : _res$data$data3.classTimeNum) || 0;
        state.worksPraisedNum = ((_res$data$data4 = res.data.data) === null || _res$data$data4 === void 0 ? void 0 : _res$data$data4.worksPraisedNum) || 0;
        state.detectionRate = ((_res$data$data5 = res.data.data) === null || _res$data$data5 === void 0 ? void 0 : _res$data$data5.detectionRate) || 0;
        state.paperAnswerRate = ((_res$data$data6 = res.data.data) === null || _res$data$data6 === void 0 ? void 0 : _res$data$data6.paperAnswerRate) || 0;
      });
    };
    __expose({
      getPanelOverview: getPanelOverview
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_unref(panelTab), {
        toolContent: "课堂互动平台授课的学生总数",
        svgName: "teacher-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[0] || (_cache[0] = [_createTextVNode(" 学生数量 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.studentNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "周期内参与展示活动的学生比例",
        svgName: "join-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[1] || (_cache[1] = [_createTextVNode(" 参与展示率 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.studentRate + '%'), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "课堂中提交作品的次数",
        svgName: "submit-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[2] || (_cache[2] = [_createTextVNode(" 课堂提交作品数 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.classTimeNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "周期内提交的作品累计获赞数量",
        svgName: "top-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode(" 作品累计获赞数 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.worksPraisedNum), 1)];
        }),
        _: 1
      }), _createVNode(_unref(panelTab), {
        toolContent: "周期内的正确答题数与总答题数的比例",
        svgName: "check-num"
      }, {
        panelName: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode(" 检测正答率 ", -1)]));
        }),
        panelNumber: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(state.detectionRate + '%'), 1)];
        }),
        _: 1
      })]);
    };
  }
};